export enum TableFilterType {
  TEXT = "text",
  SELECT = "select",
  MULTI_SELECT = "multi_select",
  DATE_RANGE = "date_range",
  NUMBER_RANGE = "number_range",
  BOOLEAN = "boolean",
}

export enum TableFilterCondition {
  EQUALS = "eq",
  NOT_EQUALS = "neq",
  CONTAINS = "contains",
  NOT_CONTAINS = "not_contains",
  STARTS_WITH = "starts_with",
  ENDS_WITH = "ends_with",
  GREATER_THAN = "gt",
  GREATER_THAN_OR_EQUAL = "gte",
  LESS_THAN = "lt",
  LESS_THAN_OR_EQUAL = "lte",
  BETWEEN = "between",
  IS_TRUE = "is_true",
  IS_FALSE = "is_false",
  IS_NULL = "is_null",
  IS_NOT_NULL = "is_not_null",
}

export interface TableFilterOption {
  value: string | number | boolean
  label: string
}

export interface TableFilterConfig {
  field: string
  label: string
  type: TableFilterType
  options?: TableFilterOption[] | (() => Promise<TableFilterOption[]>)
  paramName?: string
  conditions?: TableFilterCondition[]
  defaultCondition?: TableFilterCondition
  loopbackFilter?: boolean
}

export interface ActiveFilter {
  field: string
  condition: TableFilterCondition
  value: string | string[] | [Date, Date] | [number, number] | boolean | null
}

export const DEFAULT_CONDITIONS_BY_TYPE: Record<TableFilterType, TableFilterCondition[]> = {
  [TableFilterType.TEXT]: [
    TableFilterCondition.CONTAINS,
    TableFilterCondition.EQUALS,
    TableFilterCondition.NOT_EQUALS,
    TableFilterCondition.STARTS_WITH,
    TableFilterCondition.ENDS_WITH,
  ],
  [TableFilterType.SELECT]: [
    TableFilterCondition.EQUALS,
    TableFilterCondition.NOT_EQUALS,
    TableFilterCondition.IS_NULL,
    TableFilterCondition.IS_NOT_NULL,
  ],
  [TableFilterType.MULTI_SELECT]: [
    TableFilterCondition.CONTAINS,
    TableFilterCondition.NOT_CONTAINS,
  ],
  [TableFilterType.DATE_RANGE]: [
    TableFilterCondition.BETWEEN,
    TableFilterCondition.GREATER_THAN,
    TableFilterCondition.LESS_THAN,
  ],
  [TableFilterType.NUMBER_RANGE]: [
    TableFilterCondition.EQUALS,
    TableFilterCondition.NOT_EQUALS,
    TableFilterCondition.GREATER_THAN,
    TableFilterCondition.GREATER_THAN_OR_EQUAL,
    TableFilterCondition.LESS_THAN,
    TableFilterCondition.LESS_THAN_OR_EQUAL,
    TableFilterCondition.BETWEEN,
  ],
  [TableFilterType.BOOLEAN]: [
    TableFilterCondition.IS_TRUE,
    TableFilterCondition.IS_FALSE,
  ],
};
